import { InputText } from "primereact/inputtext"

const sectionHeaderComponent = ({
  title,
  value,
  handleFilter,
  t,
}: $TSMigrationFixMe) => {
  return (
    <div className='tw-flex tw-justify-between tw-items-end'>
      <span className='tw-text-left tw-text-alternative'>{title}</span>
      {handleFilter && (
        <div className='documentos-search w-50'>
          <span className='p-input-icon-left w-100'>
            <i className='pi pi-search' />
            <InputText
              onClick={(e) => e.stopPropagation()}
              className='w-100'
              placeholder={t("nav.directAccess.placeholderSearch")}
              value={value}
              onChange={handleFilter}
            />
          </span>
        </div>
      )}
    </div>
  )
}

export default sectionHeaderComponent
